import './index.css';
import Main from './pages/Main';
import PlatformWithAvatars from './components/PlatformWithAvatars';
import TextBox from './components/TextBox';
import React, { useState, useEffect } from 'react'

const DIALOGUES = [
  {
    text: 'Welcome to the world of Kean and Mariam!'
  },
  {
    text: "What's this? Kean is taking something out of his pocket...",
  },
  {
    text: "It's a bouquet of flowers! He's giving it to Mariam!",
    skyOverlay: 'bg-pink-800/30',
    emotion: { 'kean': 'flowers' }
  },
  {
    text: "Should Mariam accept the flowers?",
    options: [
      { text: 'Yes', value: '5 hasFlowers true' },
      { text: 'No', value: '4 hasFlowers false' },
    ],
    emotion: { 'kean': 'flowers' }
  },
  {
    text: "Mariam rejected the flowers! Kean is sad... (He will remember this.. forever..)",
    options: [
      { text: 'Bruh..', value: '6' },
    ],
    skyOverlay: 'bg-gray-800/70',
    emotion: { 'kean': 'sad' }

  },
  {
    text: "Mariam accepted the flowers! Kean is happy!",
    emotion: { 'kean': 'heart', 'mariam': 'flowers' },
  },
  {
    text: "Wait! Kean is about to ask Mariam something...",
    skyOverlay: 'bg-pink-800/30',
  },
  {
    text: "...",
  },
  {
    text: "JADEN HAS APPEARED!",
    emotion: { 'kean': 'shocked', 'mariam': 'shocked' },
    skyOverlay: 'bg-red-800/70',
  },
  {
    text: "Jaden: I AM KING JADEN! BOW DOWN TO ME!",
    emotion: { 'kean': 'shocked', 'mariam': 'sad' }
  },
  {
    text: "Jaden: I AM HERE TO RID THE WORLD OF LOVE! AND YOU TWO ARE MY FIRST TARGETS!",
    emotion: { 'kean': 'sad', 'mariam': 'sad' }
  },
  {
    text: "Jaden: I WILL DESTROY YOUR LOVE AND REPLACE IT WITH HATRED!",
    emotion: { 'kean': 'sad', 'mariam': 'sad' }
  },
  {
    text: "Kean: No! You can't do this!",
    emotion: { 'kean': 'shocked', 'mariam': 'sad' }
  },
  {
    text: "Mariam: We won't let you!",
    emotion: { 'mariam': 'shocked' }
  },
  {
    text: "Jaden: Oh really? And how do you plan to stop me?",
    emotion: { 'kean': 'sad', 'mariam': 'sad' }
  },
  {
    text: "Jaden: You can't stop me! I am invincible!",
    emotion: { 'kean': 'sad', 'mariam': 'sad' }
  },
  {
    text: "Jaden: I HAVE CLEANSED THE WOLRD OF LOVE! YOU TWO ARE THE ONLY ONES THAT REMAIN!",
    emotion: { 'kean': 'sad', 'mariam': 'sad' }
  },
  {
    text: "Jaden: THERE IS NOTHING YOU CAN DO TO STOP ME!",
    options: [
      { text: 'flower', value: '18' },
      { text: 'Do nothing', value: '17 badEnding true' },
    ]
  },
  {
    text: "Mariam used the power of the flowers to defeat Jaden!",
    emotion: { 'mariam': 'flowers-attack' }
  },
  {
    text: "Jaden: NO! HOW COULD THIS BE?! LOVE IS SUPPOSED TO BE DEAD!",
    emotion: { 'kean': 'shocked', 'mariam': 'flowers-attack' }
  },
  {
    text: "Jaden has been defeated!",
    skyOverlay: 'bg-blue-50/0',
  },
  {
    text: "Kean: Mariam, you did it! You saved us!",
  },
  {
    text: "Mariam: We did it, Kean! We saved our love!",
  },
  {
    text: "Kean: Mariam, I love you so much! You are my everything and more :)",
    emotion: { 'kean': 'heart' }
  },
  {
    text: "Will you be my valentine?",
    options: [
      { text: 'Yes', value: '26' },
      { text: 'No', value: '25' },
    ],
    emotion: { 'kean': 'heart' },
    skyOverlay: 'bg-pink-800/30',
  },
  {
    text: "I'm afraid that's not the answer I was looking for...",
    options: [
      { text: 'Okay fine', value: '26' },
      { text: 'No', value: '25 badEnding true' },
    ],
    emotion: { 'kean': 'sad' }
  },
  {
    text: "I hope you liked this little story! Happy Valentine's Day!",
  }
]

const DEBUG = false;

function App() {
  const [dialogueIndex, setDialogueIndex] = useState(0)
  const [memory, setMemory] = useState({})
  const [currentSkyOverlay, setCurrentSkyOverlay] = useState('')

  const [debugInput, setDebugInput] = useState(0)

  useEffect(() => {
    if (DIALOGUES[dialogueIndex].skyOverlay) {
      setCurrentSkyOverlay(DIALOGUES[dialogueIndex].skyOverlay)
    }
    setDebugInput(dialogueIndex)
  }, [dialogueIndex])

  const onContinue = (value) => {
    if (!value) {
      if (dialogueIndex < DIALOGUES.length - 1) {
        setDialogueIndex(prev => prev + 1)
      } else {
        setMemory(prev => ({ ...prev, 'goodEnding': true }))
      }
    } else {
      // if NaN, then its 3 options. First option is the index, second is the key for the memory, and third is the value
      const res = value.split(' ')
      const index = res[0]
      const key = res[1]
      const val = res[2]
      if (key !== undefined && val !== undefined)
        setMemory(prev => ({ ...prev, [key]: val === 'true' }))
      setDialogueIndex(parseInt(index))

    }
  }

  return (
    <div className="font-unibody w-full h-screen sky">
      <div className='absolute flex flex-col scale-90 md:scale-100 md:bg-gray-800/20 top-1 left-1 px-1 rounded-sm py-0.5'>
        <span className='text-gray-100/80 text-sm font-bold'>Be My Valentine</span>
        <span className='text-gray-100/50 text-xs italic'>Valentines Day 2025</span>

      </div>
      <div className={`z-50 absolute flex flex-col gap-2 justify-center items-center ${memory?.badEnding ? 'top-0' : '-top-full'} left-0 w-full h-full transition-all duration-500 ease-in-out bg-red-700/90`}>
        <h1 className='text-6xl font-bold text-white'>GAME OVER</h1>
        <span className='text-lg text-gray-400'>because you don't love me</span>
        <button onClick={() => { setDialogueIndex(0); setMemory(0); setCurrentSkyOverlay('') }} className='p-3 bg-yellow-600 text-lg transition-all hover:bg-yellow-500 shadow-sm font-bold text-white'>Restart</button>
      </div>

      <div className={`z-50 absolute flex flex-col gap-2 justify-center items-center ${memory?.goodEnding ? 'top-0' : '-top-full'} left-0 w-full h-full transition-all duration-500 ease-in-out bg-pink-300/90`}>
        <h1 className='text-6xl font-extrabold text-white'>Happy Valentines Day!</h1>
        <span className='text-lg text-white'>I love you {`<3`}</span>
        <button onClick={() => { setDialogueIndex(0); setMemory(0); setCurrentSkyOverlay('') }} className='p-3 bg-red-600 text-lg transition-all hover:bg-red-500 shadow-sm font-bold text-white'>Restart</button>
      </div>
      {DEBUG && <div className='absolute flex flex-col gap-2 top-0 left-0 p-5 z-50'>
        <span className="text-2xl text-white">Dialogue Index: {dialogueIndex}</span>
        <span className="text-2xl text-white">Dialogue Count: {DIALOGUES.length - 1}</span>
        <span className="text-2xl text-white">Memory: {JSON.stringify(memory)}</span>
        <span className="text-2xl text-white">Current Sky Overlay: {currentSkyOverlay}</span>
        <select value={debugInput} onChange={(e) => setDialogueIndex(parseInt(e.target.value))}>
          {DIALOGUES.map((dialogue, index) => (
            <option key={index} value={index}>{dialogue.text}</option>
          ))}
        </select>
        <button onClick={() => { setDialogueIndex(0); setMemory(0); setCurrentSkyOverlay('') }}>Reset</button>
      </div>}
      <PlatformWithAvatars emotion={DIALOGUES[dialogueIndex].emotion} memory={memory} dialogueIndex={dialogueIndex} />
      <TextBox text={DIALOGUES[dialogueIndex].text} options={DIALOGUES[dialogueIndex].options} onContinue={onContinue} memory={memory} />
      <div className={`w-full h-full transition-all duration-500 ease-in-out ${currentSkyOverlay}`}>
        <Main />
      </div>
    </div>
  );
}

export default App;
